import React from 'react';
import { NavigationItem } from './NavigationItem';
import { Separator } from "@/components/ui/separator";
import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { CreditCard } from 'lucide-react';
import logo from '../../assets/logo.png';
import CreditsDisplay from './CreditsDisplay';

export const Sidebar = ({ navigation }) => {
    const { user } = useAuth();

    // Split navigation into sections
    const mainNavigation = navigation.slice(0, 3);
    const secondaryNavigation = navigation.slice(3, -1);
    const helpItem = navigation[navigation.length - 1];

    return (
        <div className="hidden md:fixed md:inset-y-0 md:flex md:flex-col md:w-64 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700">
            <div className="h-16 flex items-center px-4 border-b border-gray-200 dark:border-gray-700">
                <Link to="/">
                    <img
                        src={logo}
                        alt="Klasite"
                        className="h-8 w-auto"
                    />
                </Link>
            </div>

            <div className="flex flex-col h-[calc(100vh-4rem)]">
                <div className="flex-1 overflow-y-auto">
                    <nav className="px-4 pt-5 space-y-1">
                        {/* Main navigation items */}
                        {mainNavigation.map((item) => (
                            <NavigationItem key={item.name} item={item} />
                        ))}

                        {/* First separator */}
                        <div className="py-4">
                            <Separator className="dark:bg-gray-700" />
                        </div>

                        {/* Secondary navigation items */}
                        {secondaryNavigation.map((item) => (
                            <NavigationItem key={item.name} item={item} />
                        ))}

                        {/* Second separator */}
                        <div className="py-4">
                            <Separator className="dark:bg-gray-700" />
                        </div>

                        {/* Help & Support item */}
                        <NavigationItem item={helpItem} />
                    </nav>
                </div>

                {/* Credits display and button at bottom */}
                <div className="px-4 pb-6">
                    <div className="mb-3 flex justify-between">
                        <div className="text-gray-600 dark:text-gray-400">
                            Credits:
                        </div>
                        <CreditsDisplay userId={user?.id} />
                    </div>
                    <Link
                        to="/buy-credits"
                        className="flex items-center justify-center gap-2 w-full px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors"
                    >
                        <CreditCard className="h-4 w-4" />
                        Get More Credits
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;